// export const serverHost = 'http://120.77.205.30/saascloud';
export const serverHost = 'http://uat.qywlsp.com.cn/saascloud';
// export const serverHost = 'http://xt.iori.top:33980/saascloud';
// export const serverHost = 'http://58.18.164.78/saascloud';
 //export const serverHost = 'http://crm1.nmdzkj.cn:82/saascloud';

/**
 * 环境信息d
 */
export const envInfo = {
  // 应用名称
  appName: 'zh-CN=平台功能展示;en-US=Platform Demo',
  // 支持的国际化语言
  //supportLang: {'zh-CN':'中文', 'en-US':'English'},
  supportLang: {'zh-CN':'中文'},
  // 模版最大限制(单位:M)
  templateMaxSize: 2,
  // 菜单配置
  sitemap: {
    // 首页配置
    home: {
      // 对应的菜单ID，不与其它菜单ID重复即可
      sitemapId: -999,
      href: '/',
      // 租户首页链接
      tenantHomeHref: '/zg/home',
      // 平台首页链接
      platformHomeHref: '/zg/home',
      // 国际化
     // displayText: 'zh-CN=首页;en-US=Home',
     displayText: 'zh-CN=首页',
    },
    // 个人中心配置，用于获取指定面包屑
    personalCenter: {
      // 对应的菜单ID，不与其它菜单ID重复即可
      sitemapId: -998,
      // 个人中心链接
      href: '/personalCenter',
      // 国际化
      displayText: 'zh-CN=个人中心;en-US=Personal center',
    },
  },
  // cookie的回写路径,支持多域名单点登录
  cookieDomain: [`${serverHost}/saas/sso`,
                // 本地调试回写模块
                //'http://127.0.0.1:8098/saas/inspection'
                ],
  // 分布式后台服务地址列
  bgApp: {
    // 默认的服务地址
    defaultPath: `${serverHost}/saas/base`,
    // SSO服务地址
    ssoPath: `${serverHost}/saas/sso`,
    // 安全中心
    securityPath: `${serverHost}/saas/security`,
    // 文档中心
    archivePath: `${serverHost}/saas/archive`,
    // 配置中心
    registryPath: `${serverHost}/saas/registry`,
    lookupPath: `${serverHost}/saas/lookup`,
    // 运维中心
    opsPath: `${serverHost}/saas/ops`,
    // 菜单管理
    sitemapPath: `${serverHost}/saas/sitemap`,
    //日志中心
    loggerPath: `${serverHost}/saas/logger`,//'http://127.0.0.1:8082/saas/logger',
    // 调度中心
    clockyPath: `${serverHost}/saas/clocky`, // http://localhost.iori.top:8088/clocky,
    //视频路径地址
    mediaPath: 'ws://uat.qywlsp.com.cn/media',
    //视频服务器地址
    yookaPath: 'http://uat.qywlsp.com.cn/yooka',
    // 推送服务器
    sprayPath: 'ws://uat.qywlsp.com.cn/saas/spray?guid=gbase|gmaintenance|ginspection|gorder|isso|iot|nanhai|inotify|itag|iorganization',
    // 基础业务的服务地址
    basePath: `${serverHost}/saas/base`,
    //组织结构服务地址
    organizationPath: `${serverHost}/saas/organization`,
    //巡检服务地址
    inspectionPath: `${serverHost}/saas/inspection`,
    //维保服务地址
    maintenancePath: `${serverHost}/saas/maintenance`,
    //工单服务地址
    orderPath: `${serverHost}/saas/order`,
    //抽取中心
    pumpPath: `${serverHost}/saas/pump`,
    //南海IOT数据中心
    nanhaiPath: `${serverHost}/saas/nanhai`,
    //通知管理
    notifyPath: `${serverHost}/saas/notify`,
    //租户服务
    tenantPath: `${serverHost}/saas/tenant`,
    //标签服务
    tagPath: `${serverHost}/saas/tag`,
    //视频监控服务
    cameraPath: `${serverHost}/saas/camera`,
   //能源服务
    energyPath: `${serverHost}/saas/energy`,
    // 考勤服务
    attendancePath: `${serverHost}/saas/attendance`,
  }
};
